<template>
  <Grid gap="var(--r-space-md)" class="license relative-position">
    <AssignLicenseModal
      v-if="modalLicensePeriods"
      :showing.sync="showLicenseModal"
      :licenses="modalLicensePeriods"
      @close="closeModal"
      @done="onDone"
      @refetch="openModal"
    />

    <header>
      <Grid
        v-if="licensePeriods && licensePeriods.length"
        gaf="column"
        justify-content="space-between"
        align-items="center"
      >
        <RDropdown
          v-model="licensePeriodId"
          placeholder="Select license period"
          :options="licensePeriodsOptions"
          map-options
          emit-value
          no-label
          no-hint
        />

        <Grid gaf="column" align-items="center" gap="var(--r-space-md)">
          <RBtn size="small" type="primary" @click="openModal">Assign</RBtn>
          <RBtn v-if="licensePeriod" size="small" type="link" :to="`/licenses/${licensePeriod.license.id}`">
            go to license
          </RBtn>
        </Grid>
      </Grid>

      <Grid
        v-if="licensePeriods && !licensePeriods.length"
        gaf="column"
        justify-content="space-between"
        align-items="center"
      >
        <div class="text-subtitle-1 text-secondary-1">The subscription has not been assigned a license</div>
        <RBtn size="small" type="primary" @click="openModal">Assign</RBtn>
      </Grid>
    </header>

    <Grid v-if="licensePeriod" gtc="1.5fr 1fr" gap="var(--r-space-md) var(--r-space-sp)">
      <Grid align-content="start" gap="var(--r-space-md) var(--r-space-sp)">
        <TabTerms :data="licensePeriod.terms" />
        <TabSummary :data="licensePeriod.summary" />

        <Notes
          :key="`notes-${licensePeriod.id}`"
          :entity="{ name: 'license-period', id: licensePeriod.id }"
          store-namespace="license-periods"
        />
      </Grid>

      <Grid align-content="start" gap="var(--r-space-md) var(--r-space-sp)">
        <LicenseFile :file="licensePeriod.license_file" />
        <Attachments
          :key="`attachments-${licensePeriod.id}`"
          :entity="{ name: 'license-period', id: licensePeriod.id }"
          store-namespace="license-periods"
        />
        <Links
          :key="`links-${licensePeriod.id}`"
          :dropdown-initial-value="linksCategories"
          :entity="{ name: 'license-period', id: licensePeriod.id }"
          store-namespace="license-periods"
        />
        <TabSubscriptions :data="licensePeriod.subscriptions" />
      </Grid>
    </Grid>

    <QInnerLoading :showing="!licensePeriods || requestInProgress">
      <QSpinnerHourglass size="3.5rem" color="primary-1" />
    </QInnerLoading>
  </Grid>
</template>

<script>
import * as apiTo from '@/modular-api'
import { linksCategories } from '@/reusable/data/links-categories'
// Libraries
import { mapGetters } from 'vuex'
import { cloneDeep } from 'lodash'
// Components
import AssignLicenseModal from './components/AssignLicenseModal'
import Attachments from '@components/lm-blocks/Attachments.vue'
import Links from '@components/lm-blocks/Links.vue'
import Notes from '@components/lm-blocks/Notes.vue'
import { TabSubscriptions, TabSummary, TabTerms } from '@/reusable/license'
import LicenseFile from '@/reusable/LicenseFile/LicenseFile'

export default {
  components: {
    AssignLicenseModal,
    Attachments,
    Links,
    Notes,
    TabSubscriptions,
    TabSummary,
    TabTerms,
    LicenseFile
  },

  props: {
    id: [Number, String] // from route
  },

  data: () => ({
    licensePeriods: null,
    requestInProgress: false,
    showLicenseModal: false,
    modalLicensePeriods: null,
    licensePeriodId: null,
    licensePeriod: null
  }),

  computed: {
    ...mapGetters('subscription-show', ['subscription']),

    licensePeriodsOptions() {
      const periods = cloneDeep(this.licensePeriods)
      return periods.map(period => {
        period.label = `${period.name} (${this.getPeriod(period)})`
        period.value = period.id
        return period
      })
    },

    linksCategories
  },

  watch: {
    licensePeriodId: 'getLicensePeriod'
  },

  created() {
    this.getLicenses()
  },

  methods: {
    getLicenses() {
      if (this.requestInProgress) return
      this.requestInProgress = true

      apiTo
        .GET_SUBSCRIPTION_LICENSE_PERIODS(this.id)
        .then(({ data }) => {
          this.licensePeriods = data.result
          this.licensePeriodId = data.result?.[0]?.id || null
        })
        .finally(() => (this.requestInProgress = false))
    },

    openModal() {
      apiTo.GET_SUBSCRIPTION_LICENSE_PERIODS_AVAILABLE(this.subscription.id).then(({ data }) => {
        this.modalLicensePeriods = data.result
        this.showLicenseModal = true
      })
    },

    closeModal() {
      this.modalLicensePeriods = null
      this.showLicenseModal = false
    },

    onDone() {
      this.closeModal()
      this.getLicenses()
    },

    getLicensePeriod(periodId) {
      this.requestInProgress = true

      apiTo
        .GET_LICENSE_PERIOD(periodId)
        .then(({ data }) => {
          this.licensePeriod = data.result
        })
        .finally(() => (this.requestInProgress = false))
    }
  }
}
</script>
